import { useLocation } from 'react-router-dom';
import { Navbar } from '../navbar/navbar.comp';

export const Layout = ({ children }: any) => {
    const location = useLocation();
    const hideNavbarOnRoutes = ['/login', '/logout'];

    const shouldHideNavbar = hideNavbarOnRoutes.includes(location.pathname);

    return (
        <div>
            {!shouldHideNavbar && <Navbar />}
            <main>{children}</main>
        </div>
    );
};
